"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseCLass = function BaseCLass() {
    _classCallCheck(this, BaseCLass);
};

exports.default = BaseCLass;